import mapboxgl from 'mapbox-gl';
import { useEffect, useRef, useState } from 'react';
mapboxgl.accessToken = window.mainSiteData.mapboxAPIToken;
const RESIZE_DEBOUNCE = 100;
export default function useMap(style = 'mapbox://styles/romeodigital/ckzxin1ui000315o9x2usjle7?optimize=true') {
    const ref = useRef(null);
    const map = useRef(undefined);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        const container = ref.current;
        if (container && !map.current) {
            // Create map instance
            const instance = new mapboxgl.Map({
                container,
                style,
                center: [153.1845, -27.9284],
                minZoom: 8,
                zoom: 9,
                maxZoom: 12,
                cooperativeGestures: true,
                dragRotate: false,
            });
            // Store map instance
            map.current = instance;
            // Add zoom and rotation controls to the map.
            instance.addControl(new mapboxgl.NavigationControl());
            // Event listeners
            instance.once('load', () => {
                instance.resize();
                setLoaded(true);
            });
            let resizeTimeout = -1;
            const handleResize = () => {
                clearTimeout(resizeTimeout);
                resizeTimeout = window.setTimeout(() => instance.resize(), RESIZE_DEBOUNCE);
            };
            window.addEventListener('resize', handleResize);
            // Cleanup
            return () => {
                clearTimeout(resizeTimeout);
                window.removeEventListener('resize', handleResize);
                instance.remove();
                map.current = undefined;
            };
        }
    }, [ref, map, setLoaded]);
    return { ref, map, loaded };
}
